import { Button, Container, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useScreenSize } from "src/hooks/useScreenSize";
import { fetchAllUsersProjects } from "src/lib/global";
import InspirationsItems from "./InspirationsItems";
import { LocalizationContext, SelectedSkillContext } from "src/lib/context";

const InspirationsMain = () => {
  const { inspirationsPage, uiGeneral } =
    useContext(LocalizationContext).localeStrings;
  const { selectedSkills, setSelectedSkills } =
    useContext(SelectedSkillContext);

  // There are two different component full of items in which the location of the items are different. 2 is the default number of components. After "Load more" button is clicked, these numbers are updated. We will then render based on the number of components.
  const [numOfContainersDesktop, setNumOfContainersDesktop] = useState<number>(
    () => 2
  );
  const [numOfContainersMobile, setNumOfContainersMobile] = useState<number>(
    () => 2
  );
  const smAndDown = useScreenSize("sm", "down");

  const [projects, setProjects] = useState<any[]>([]);
  const [visibleProjects, setVisibleProjects] = useState<number>(
    smAndDown ? 6 : 9
  );

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchAllUsersProjects();

      const selected: any[] = [];
      if (selectedSkills.length === 0) {
        setProjects(data);
        return;
      }

      data.forEach((project: any) => {
        project?.skills?.forEach((skill: any) => {
          if (
            selectedSkills.some(
              (s) => s?.toLowerCase() === skill?.toLowerCase()
            )
          ) {
            selected.push(project);
          }
        });
      });
      setProjects(selected);
    };
    fetchData();
  }, [selectedSkills]);

  return (
    <Container className="inspire__main">
      <div className="inspire__main--header">
        <Typography variant="h2">{inspirationsPage.projectsTitle}</Typography>
        <Typography>{inspirationsPage.projectsSubtitle}</Typography>
      </div>

      <div className="inspire__main--allItems">
        {projects.length > 0 && (
          <InspirationsItems
            items={projects.slice(0, visibleProjects)}
            isMobile={smAndDown}
          />
        )}
      </div>

      <Button
        variant="contained"
        className="inspire__loadMore w-full"
        onClick={() =>
          setVisibleProjects(visibleProjects + (smAndDown ? 6 : 8))
        }
        children={uiGeneral.loadMore}
      />
    </Container>
  );
};

export default InspirationsMain;
